import { environment } from "../environments/environment";

export class AuthApi {
    static readonly login = environment.ADMIN_URL + 'auth/login';
    static readonly forgotPassword = environment.ADMIN_URL + 'auth/forgot-password';
    static readonly resetPassword = environment.ADMIN_URL + 'auth/reset-password';
    static readonly logout = environment.ADMIN_URL + 'logout';
    static readonly changePassword = environment.ADMIN_URL + 'change-password';
    static readonly updateUserInfo = environment.ADMIN_URL + 'update-userinfo';
    static readonly profile = environment.ADMIN_URL + 'profile';

}


export class EmployeeApi {
    static readonly getEmployeeList = environment.ADMIN_URL + 'employees';
    static readonly addEmployee = environment.ADMIN_URL + 'employee/create';
    static readonly updateEmployee = environment.ADMIN_URL + 'employee/:id';
    static readonly deleteEmployee = environment.ADMIN_URL + 'employee/:id';
    static readonly employeeDetails = environment.ADMIN_URL + 'employees/:id';
}

export class CustomerApi {
    static readonly addCustomer = environment.ADMIN_URL + 'customers/add';
    static readonly editcustomer = environment.ADMIN_URL + 'customers/edit/:customerId';
    static readonly updateCustomerStatus = environment.ADMIN_URL + 'customers/update-status/:customerId';
    static readonly getCustomerList = environment.ADMIN_URL + 'customers';
    static readonly getGSTReturnList = environment.ADMIN_URL + 'gst-returns';
    static readonly getCustomerDetails = environment.ADMIN_URL + 'customers/:id';
    static readonly importCustomers = environment.ADMIN_URL + 'import-customers';
    static readonly updateGSTQuery = environment.ADMIN_URL + 'update-gst-query/:customerId';
    static readonly updateGSTStatus = environment.ADMIN_URL + 'update-gst-status/:customerId';
    static readonly updateGSTReturn = environment.ADMIN_URL + 'update-gst-returns';
    static readonly gstReturnsforCustomer = environment.ADMIN_URL + 'customer/:customerId/gst-returns';
    static readonly addNotes = environment.ADMIN_URL + 'customer/add-notes';
    static readonly editNotes = environment.ADMIN_URL + 'customer/edit-notes';
    static readonly deleteNotes = environment.ADMIN_URL + 'customer/delete-notes/:customerId';
    static readonly getNotes = environment.ADMIN_URL + 'customer/:customerId/get-notes';
    static readonly deleteGSTQuery = environment.ADMIN_URL + 'delete-gst-returns';
    static readonly addCustomColumn = environment.ADMIN_URL + 'addCustomColumn';
    static readonly addCustomColumn__ = environment.ADMIN_URL + 'add-custom-column';
    static readonly deleteCustomColumn = environment.ADMIN_URL + 'delete-custom-column/:id';
    static readonly updateCustomColumn = environment.ADMIN_URL + 'custom-columns/update/:id';
    static readonly getGroupNames = environment.ADMIN_URL + 'get-group-names';
    static readonly addToGroupName = environment.ADMIN_URL + 'add-group-name';
    static readonly exportToExcel = environment.ADMIN_URL + 'export-gst-returns-to-excel';
}

export class FAQApi {
    static readonly getFAQList = environment.API_URL + 'faqs';
    static readonly addFAQ = environment.ADMIN_URL + 'create-faq';
    static readonly updateFAQ = environment.ADMIN_URL + 'edit-faq';
    static readonly deleteFAQ = environment.ADMIN_URL + 'delete-faq';
    static readonly faqDetail = environment.API_URL + 'faqs';
}

export class ContactApi {
    static readonly getContactList = environment.ADMIN_URL + 'list-contact';
    static readonly resolveContactQuery = environment.ADMIN_URL + 'contact-resolved';
}

export class DashboardApi {
    static readonly dashboard = environment.ADMIN_URL + 'dashboard';
    static readonly registrations = environment.ADMIN_URL + 'dashboard/registrations';
    static readonly heatmap = environment.ADMIN_URL + 'dashboard/heatmap';
    static readonly teams = environment.ADMIN_URL + 'dashboard/teams';
    static readonly revenue = environment.ADMIN_URL + 'dashboard/revenue';
    static readonly gstrGraph = environment.ADMIN_URL + 'dashboard/gstr-graphs';
}

export class NotificationApi{
    static readonly getNotifications = environment.ADMIN_URL + 'notifications';
    static readonly getEventNotifications = environment.ADMIN_URL + 'events/:eventId/notifications';
    static readonly deleteNotification = environment.ADMIN_URL + 'notifications/:notificationId/delete';
    static readonly receivedNotifications = environment.ADMIN_URL + 'notifications/received';
}

export class SettingsApi{
    static readonly getSettings = environment.API_URL + 'settings/:key';
    static readonly updateSettings = environment.ADMIN_URL + 'settings';
}
